import { render } from "./ProfileLikes.vue?vue&type=template&id=33085145"
import script from "./ProfileLikes.vue?vue&type=script&lang=js"
export * from "./ProfileLikes.vue?vue&type=script&lang=js"
script.render = render

export default script